<div class="morphbox-container">
  <div class="morphbox clearfix">
    <table class="table table-bordered pull-left raised">
      <tbody>
        <tr *ngFor="let row of morphbox.rows; let i = index">
          <th class="cell-label-container border-black">
            <i
              class="mine-icon mdi-social-person mdi-material-lightgreen clickable"
              *ngIf="row.created_by === session.me._id"></i>
            <div class="content">
              {{ row.text }}
            </div>
            <div class="cell-label">
              <!--TODO remove inline style-->
              <div class="hover-container">
                <i
                  class="fa fa-times"
                  *ngIf="
                    permissions.session.data.morphboxes.rows.delete(
                      session,
                      morphbox,
                      row
                    )
                  "
                  (click)="deleteMorphboxRow(row)"></i>
              </div>
            </div>
          </th>
          <td
            *ngFor="let element of row.elements"
            [ngClass]="{
              success: element.created_by === session.me._id,
              clicked: element.clicked,
            }"
            class="cell-label-container"
            (click)="element.clicked = !element.clicked">
            <div class="content">
              {{ element.text }}
            </div>
            <div class="cell-label">
              <div class="hover-container">
                <i
                  class="fa fa-times"
                  *ngIf="
                    permissions.session.data.morphboxes.rows.elements.delete(
                      session,
                      row,
                      element
                    )
                  "
                  (click)="deleteMorphboxElement(row, element)"></i>
              </div>
            </div>
          </td>
          <td
            *ngIf="
              permissions.session.data.morphboxes.rows.elements.post(
                session,
                row
              )
            ">
            <div
              class="btn btn-primary fill-width cell-button cell-button-big"
              (click)="openNewMorphboxElementModal(row)">
              + value
            </div>
          </td>
        </tr>
        <tr
          *ngIf="
            permissions.session.data.morphboxes.rows.post(session, morphbox)
          ">
          <th>
            <div
              class="btn btn-primary fill-width cell-button cell-button-big"
              (click)="openNewMorphboxRowModal()">
              + property
            </div>
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- CURRENT SELECTION -->
<!--
<div ng-if="currentIdeationSession.phase === 3" class="col-lg-3">
<table class="table table-bordered morphbox raised pull-right">
  <tbody>
  <tr ng-if="sizeOf(currentSelection) > 0" class="cell-half-height">
    <th>
      <div class="label label-info clickable fill-width cell-button" ng-click="clearSelection()">
        <span class="fa fa-times"></span>
        clear selection
      </div>
    </th>
  </tr>
  <tr ng-repeat="selection in getCurrentSelectionArray() | orderBy: 'rowIndex'" class="cell-half-height">
    <td>
      {{selection.name}}
    </td>
  </tr>
  <tr ng-if="sizeOf(currentSelection) < 0" class="cell-half-height">
    <td>
      <i class="mdi-alert-error mdi-material-deeporange" style="font-size: 20px;"></i>
      Select min. 2 cells
    </td>
  </tr>
  <tr class="cell-half-height" ng-if="sizeOf(currentSelection) >= 0">
    <th>
      <div class="label label-success clickable fill-width cell-button" ng-click="openInputModal('new_final_idea', 0, 0, element)">
        <span class="fa fan-plus"></span>
        save new idea
      </div>
    </th>
  </tr>
  </tbody>
</table>
</div>
-->
